import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allChildren: [],
  allHierarchy: null
}

const groupSlice = createSlice({
  name: "groupSlice",
  initialState,
  reducers: {
    saveGroupHierarchy: (state, action) => {
      state.allHierarchy = action.payload.hierarchy;
    },
    saveGroupList: (state, action) => {
      state.allChildren = action?.payload?.list
    }
  },
});

export const { saveGroupHierarchy, saveGroupList } = groupSlice.actions;
export default groupSlice.reducer;